import CssBaseline from '@material-ui/core/CssBaseline';
import * as serviceWorker from '@tracker/shared/src/ServiceWorker/ServiceWorker';
import ThemeProvider from '@tracker/shared/src/Theme/ThemeProvider';
import {SnackbarProvider} from 'notistack';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

ReactDOM.render(
    <ThemeProvider>
        <SnackbarProvider maxSnack={1}>
            <CssBaseline/>
            <App/>
        </SnackbarProvider>
    </ThemeProvider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
